import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { InvutilexistenciasService } from '../invservicios/invutilexistencias.service';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { Invutilextencia } from '../invinterfaces/invutilextencia';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { ConfirmationService, MessageService, SelectItem } from 'primeng';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { InvTrnkardexp } from '../invinterfaces/invtrnkardexp';
import { InvmaearticuloService } from '../invservicios/invmaearticulo.service';
import { Usuario } from 'src/app/usuario';//CDPJ
import { ReportesService } from '../../servicios/reporte.service';//CDPJ

@Component({
  selector: 'app-invutilexistencias',
  templateUrl: './invutilexistencias.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InvutilexistenciasComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  btnGuardar: boolean;

  btnBuscar: boolean;
  rowStyle;
  largo = '258';
  rowSelection = 'multiple';
  invExistencias: Invutilextencia[] = [];
  seletedInvExistencia: Invutilextencia;
  defaultColDefInvutilExtencias;



  public frameworkComponents;






  // Busqueda
  displayDialogBus: boolean;
  displayDialogBusquedaFast: boolean;
  displayDialogKardex = false;
  displayDialogBusqueda: boolean;
  types: SelectItem[];
  busquedacampos = [];
  tabla: string;
  consulta: string;
  consulta1: string;
  consulta2: string;
  consulta3: string;
  arregloCons: any[] = [];
  arregloBus = [];
  where: string;
  opcion: string;
  condicion: string;

  arrayCompleto = true;
  spin = false;
  porcentaje = 0;
  showBar = false;

  txtCodBodega = '';
  boolconbod: boolean;//CDPJ
  boolblockbod: boolean;//CDPJ
  codigos: string[] = [];

  desplegarCheck = false;
  codArticulo: string;
  configuraciones = [
    { valor: 0 }, // Pestañas hábiles para maestro de inventario punto de venta
    { valor: 0 }, // precio con IVA
    { valor: 0 }, // desplegar existencias
    { valor: 0 }, // valor IVA
    { valor: 0 },    //ver lista de precios
    { valor: 0 }, //colocar la ubicacion de la bodega en vez de la del artículo
    { valor: 0 }, //colocar la referencias de de existencias por bodega del maestro de artículos
  ];


  defaultColDefKardex;
  trnkardexp: InvTrnkardexp[] = [];
  largokardex = '200';


  columnDefInvExistencias;
  columnDef = [
    {
      headerName: 'N', field: 'NUMERO', editable: false, width: 50,
    },
    {
      headerName: 'Bodega', field: 'BOD_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Ubicación', field: 'ART_UBICACION', cellEditor: 'cellPrueba', width: 100, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Grupo', field: 'NOMBRE', cellEditor: 'cellPrueba', width: 100, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Código', field: 'ART_CODIGO', cellEditor: 'cellPrueba', width: 100, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Código alterno', field: 'ART_CODIGOALT1', cellEditor: 'cellPrueba', width: 100, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Nombre', field: 'ART_NOMBRE', cellEditor: 'cellPrueba', width: 300, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
    {
      headerName: 'Existencia', field: 'EXISTENCIA', cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          tienecalculos: false,
        }
      }
    },
  ]; // ahi termina

  defaultColumnDef = this.columnDef;


  columnDefsKardex = [
    {
      headerName: 'Fecha', field: 'TRNART_FECHAES'
    },
    {
      headerName: 'Hora', field: 'TRNART_HORA'
    },
    {
      headerName: 'Bodega', field: 'BOD_CODIGO'
    },
    {
      headerName: 'Origen', field: 'TRNART_ORIGEN'
    },
    {
      headerName: 'Documento', field: 'TRNART_REFERENCIA', width: 200,
    },
    {
      headerName: 'T.', field: 'TRNART_TIPO'
    },
    {
      headerName: 'Entradas', field: 'TRNART_CANTIDAD_E', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Salidas', field: 'TRNART_CANTIDAD_S', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Costo Uni.', field: 'TRNART_COSTO_UNITARIO', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Costo Tota', field: 'TRNART_COSTOT', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Saldo Uni', field: 'TRNART_CANTIDAD_SALDO', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Costo Pro', field: 'TRNART_COSTOPROM', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Total', field: 'TRNART_COSTOT_SALDO', cellStyle: { textAlign: 'right' },
    },
    {
      headerName: 'Número', field: 'TRNART_NUMERO'
    },
  ];

  constructor(
    private invUtilExistService: InvutilexistenciasService,
    private messageService: MessageService,
    private init: NuevoComponentService,
    private errorService: ErroresBaseDatosService,
    private confirmationService: ConfirmationService,
    public artService: InvmaearticuloService, private datePipe: DatePipe,
    public usuario: Usuario,//CDPJ
    private reporteSer: ReportesService
  ) {
    this.columnDefInvExistencias = this.columnDef;
    this.agTable();
  }


  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefInvutilExtencias = {
      editable: false,
      width: 130,
      objeto: 'utilExten'
    };
    this.defaultColDefKardex = {
      editable: false,
      width: 130,
      objeto: 'trnkardexp',
      resizable: true
    };
  }

  ngOnInit(): void {
    this.btnBuscar = false;
    // this.btnGuardar = false;
    this.getConfiguraciones();

  }



  async buscarBodegas(txtCodBodega) {
    if (txtCodBodega !== '') {
      // await this.generateSingle( txtCodBodega );
      this.buscarArticulos([txtCodBodega]);
    } else {
      if (txtCodBodega === undefined) {
        txtCodBodega = '';
      }

      // const opcionbusqueda1 = opcionbusqueda;
      this.types = [
        { label: 'Codigo', value: 'BOD_CODIGO' },
        { label: 'Nombre', value: 'BOD_NOMBRE' }
      ];
      this.busquedacampos = [txtCodBodega, ''];
      this.consulta = '';
      this.tabla = 'inv_maebodega';
      this.where = '';

      this.invUtilExistService.busquedaBodega(txtCodBodega).then((datos: any[]) => {
        this.arregloCons = datos;
        this.displayDialogBusquedaFast = true;
      });

    }
  }






  async getConfiguraciones() {
    /**
     * ===================        DECLARAR PROMESAS   ============================
     */
    try {

      /**
       *  =============    EJECUTAR PROMESAS ==============
       */
      let data2
      let data = await this.invUtilExistService.erConfmainvptvta(); // si está activada trae ART_CODIGOALT1 y si está en cero elimna todas las lista de precios sino solo deja una lista
      for (const cfgValor of data) {
        this.configuraciones[0].valor = cfgValor.CFG_VALOR1;
      }

      data = await this.invUtilExistService.erconfpreincivae(); //se usa en la consulta que trae los precios
      for (const cfgValor of data) {
        this.configuraciones[1].valor = cfgValor.CFG_VALOR1;
      }

      data = await this.invUtilExistService.erconfnodeexneg(); //no esta funcionando solo cuando trae la lista de precios y segun eso trae o no el precio
      for (const cfgValor of data) {
        this.configuraciones[2].valor = cfgValor.CFG_VALOR1;
      }

      data = await this.invUtilExistService.erimpporcentaje(); // trae el impuesto vigente está mal antes estaba CFG_VALOR1 ahora IMP_porcentaje
      for (const cfgValor of data) {
        this.configuraciones[3].valor = cfgValor.IMP_PORCENTAJE;
      }
      //CDPJ
      data = await this.invUtilExistService.ervrlisprecios(this.usuario.identificacion); // lee del maestro de uusarios si el usuario tiene permisos para Visualizar lista de precios en consultar existencia si se usa

      console.log(data)
      if (data !== null && data !== undefined) {
        for (const cfgValor of data) {
          if (cfgValor.USU_VERPRECIOCONSULEXIS === null || cfgValor.USU_VERPRECIOCONSULEXIS === undefined) {
            this.configuraciones[4].valor = 1;
          } else {
            this.configuraciones[4].valor = cfgValor.USU_VERPRECIOCONSULEXIS;
          }
        }
      } else {
        this.configuraciones[4].valor = 1;
      }
      console.log('val', this.configuraciones[4].valor)
      //---------------------------------------------------
      data = await this.invUtilExistService.ervrconsboduser(); // Considerar bodega del usuario en consultar existencias si se usa y a penas se abre el formulario coloca la bodega parametrizada
      if (data !== null && data !== undefined) {
        for (const cfgValor of data) {
          if (cfgValor.CFG_VALOR1 === 1) {
            this.boolconbod = true;
            data2 = await this.invUtilExistService.ervrboduser(this.usuario.identificacion);
            if (data2 !== null && data2 !== undefined) {
              for (const cfgValor of data2) {
                if (cfgValor.BOD_CODIGO === null || cfgValor.BOD_CODIGO === undefined || cfgValor.BOD_CODIGO === '') {
                  this.boolblockbod = false;
                } else {
                  this.boolblockbod = true;
                  this.txtCodBodega = cfgValor.BOD_CODIGO
                }
              }
            }
          }
          else {
            this.boolconbod = false;
          }
        }
      } else {

        this.boolconbod = false;
      }
      data = await this.invUtilExistService.ervrubicacionbod();// Considerar la ubicación del maestro de Bodega en el detalle de consultar existencias
      //console.log(data)
      if (data !== null && data !== undefined) {
        for (const cfgValor of data) {
          if (cfgValor.CFG_VALOR1 === null || cfgValor.CFG_VALOR1 === undefined) {
            this.configuraciones[5].valor = 0;
          } else {
            this.configuraciones[5].valor = cfgValor.CFG_VALOR1;
          }
        }
      } else {
        this.configuraciones[5].valor = 0;
      }
      data = await this.invUtilExistService.ervrubicacionrefart(); //Activar campo de referencia de bodegas en existencias por bodega si esta activa trae la referencia y la coloca como ubicación
      console.log(data)
      if (data !== null && data !== undefined) {
        for (const cfgValor of data) {
          if (cfgValor.CFG_VALOR1 === null || cfgValor.CFG_VALOR1 === undefined) {
            this.configuraciones[6].valor = 0;
          } else {
            this.configuraciones[6].valor = cfgValor.CFG_VALOR1;
          }
        }
      } else {
        this.configuraciones[6].valor = 0;
      }
      //CDPJ


      if (this.configuraciones[0].valor === 0) {
        this.aggrid.hideColumn('ART_CODIGO', false);
      }

      if (this.invUtilExistService.usuarioEsquema.esquema === 'UIO1793189664001'
        && this.invUtilExistService.usuario.codperfil === 'VENT') {
        this.aggrid.hideColumn('EXISTENCIA', false);

      }


    } catch (e) {
      console.error(e);
      const mensaje = this.errorService.generarMensajeErrorCompleto(e.error);
      this.mensajeAlerta('error', 'Error', mensaje);
    };
  }



  setIndice() {
    this.invExistencias.map(x => {
      x.NUMERO = this.invExistencias.indexOf(x) + 1;
    });
  }

  buscarArticulo() {

    if (this.txtCodBodega === '' && this.desplegarCheck === false) {
      this.mensajeAlerta('info', 'Información', 'Debe seleccionar una bodega para poder realizar la consulta');
      return;
    }

    const fechaActual = Date.now();
    const datePipe = new DatePipe('en-US');
    const fecha = datePipe.transform(fechaActual, 'dd/MM/yyyy');

    this.opcion = 'BUSCAR';
    this.types = [
      { label: 'Codigo', value: 'ART_CODIGO' },
      { label: 'Nombre', value: 'ART_NOMBRE' },
      { label: 'Grupo', value: 'GRUP_CODIGO' },
      { label: 'Nombre corto', value: 'ART_nombrec' },
    ];

    this.busquedacampos = ['', '', '', ''];


    //CDPJ
    if (this.configuraciones[0].valor === 0) /*IF MAINVPTVTA==0*/ {
      if (this.configuraciones[5].valor === 1) {
        this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
          'ART_UNIDADVENTA, BOD_UBICACION as ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
        this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
          'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
          'ART_CODIGO, ' + '\'01\'' + ', \'';
        this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
          'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
          ' \'\',' + '\'01\'' + ')AS COSTO';
      } else {
        //CDPJ
        if (this.configuraciones[6].valor === 1) {
          this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
            'ART_UNIDADVENTA, INV_FNC_OBTENER_ARTEXRREF(ART_CODIGO,\'01\',BOD_CODIGO) as ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
          this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
            'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
            'ART_CODIGO, ' + '\'01\'' + ', \'';
          this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
            'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
            ' \'\',' + '\'01\'' + ')AS COSTO';
        } else {
          this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
            'ART_UNIDADVENTA, ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
          this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
            'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
            'ART_CODIGO, ' + '\'01\'' + ', \'';
          this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
            'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
            ' \'\',' + '\'01\'' + ')AS COSTO';
        }
        //CDPJ
      }
    } else {
      if (this.configuraciones[5].valor === 1) {
        this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
          'ART_UNIDADVENTA, BOD_UBICACION as ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
        this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
          'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
          'ART_CODIGO, ' + '\'01\'' + ', \'';
        this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
          'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
          ' \'\', ' + '\'01\'' + ') AS COSTO, ART_CODIGOALT1';

      } else {
        //CDPJ
        if (this.configuraciones[6].valor === 1) {
          this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
            'ART_UNIDADVENTA, INV_FNC_OBTENER_ARTEXRREF(ART_CODIGO,\'01\',BOD_CODIGO) as ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
          this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
            'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
            'ART_CODIGO, ' + '\'01\'' + ', \'';
          this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
            'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
            ' \'\', ' + '\'01\'' + ') AS COSTO, ART_CODIGOALT1';
        } else {
          this.consulta = '\' AS BOD_CODIGO, ART_CODIGO, ART_NOMBRE, ' +
            'ART_UNIDADVENTA, ART_UBICACION, INV_FNC_OBTENEREXISTARTCL (\'FAC\',ART_CODIGO, \'';
          this.consulta1 = '\',\'\',' + '\'01\'' + ') AS EXISTENCIA, GRUP_CODIGO, ' +
            'INV_FNC_OBTENER_NOMBRE_GRUPO(GRUP_CODIGO) AS NOMBRE, INV_FNC_CANTPARTESRESERVADAS(' +
            'ART_CODIGO, ' + '\'01\'' + ', \'';
          this.consulta2 = '\', \'' + fecha + '\', \'\') ' +
            'AS PRERESERVADO, INV_FNC_OBTENERCOSTOPROM(ART_CODIGO, TO_DATE(\'' + fecha + '\', \'DD/MM/YYYY\'),' +
            ' \'\', ' + '\'01\'' + ') AS COSTO, ART_CODIGOALT1';
        }
        //CDPJ
      }

    }
    //CDPJ


    if (this.desplegarCheck === true) {
      this.arregloCons = this.codigos;
    } else {
      this.arregloCons = [];
      this.arregloCons.push(this.txtCodBodega);
    }




    this.tabla = 'INV_MAEARTICULO,inv_maebodega';
    this.condicion = '';
    //CDPJ
    if (this.configuraciones[5].valor === 1 || this.configuraciones[6].valor === 1) {
      this.condicion = ' bod_codigo=\'' + this.txtCodBodega + '\'';
    }
    //CDPJ
    // this.arregloCons = [];
    this.displayDialogBusqueda = true;
  }



  manejarSenales(valor) {

    switch (valor) {
      case 'Cancelar':
        this.cargar();
        break;
      case 'Buscar':
        this.buscarArticulo();
        break;
      case 'Kardex':
        this.abrirKardex();
        break;
      case 'Rayo':
        this.buscarTodos();
        break;
      case 'Salir':
        this.init.tabs.splice(this.init.tabindex, 1);
        break;
      case 'Excel':
        this.imprimirexcel();
        break;
    }
  }
  //CDPJ
  async imprimirexcel() {
    this.spin = true;
    //1.consultar nombre del procesos en el reporte específico de pantalla 
    await this.ejecutarReporte(this.invExistencias)
    let strPantallaArchivoRP = 'INV_RE1_CONSUL_EXIST_BEST' + '_XLS.jasper';
    this.spin = false;
    this.reporteSer.generarReporte(strPantallaArchivoRP, '', true, '').subscribe(response => {
      console.log(response);
      let base64: string = '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';
      base64 = response;
      let byteCharacters = atob(base64);
      let byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        let slice = byteCharacters.slice(offset, offset + 512);
        let byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let bytearray = new Uint8Array(byteNumbers);
        byteArrays.push(bytearray);
      }
      let blob = new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const fileURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('style', 'display: none;');
      a.href = fileURL;
      a.download = strPantallaArchivoRP + '.xlsx';
      a.click();
      window.URL.revokeObjectURL(fileURL);

    }, error => {
      this.mensajeAlerta('info', 'Información', 'Error al generar el reporte. Revise la configuración');
    });
  }
  async ejecutarReporte(articulos: Invutilextencia[]) {
    const eli = await this.invUtilExistService.eliminaexisteciasprep();
    for (const articulo of articulos) {
      const detexis = await this.invUtilExistService.insertarexisteciaspre(articulo, this.usuario.identificacion);
    }

  }
  //CDPJ
  cargar() {
    this.invExistencias = [];
    if (this.configuraciones[0].valor === 0) {
      this.columnDef.splice(8);
    } else {
      this.columnDef.splice(9);
    }

    this.columnDefInvExistencias = this.columnDef;
    this.aggrid.refreshColumnDefs();
    this.aggrid.refreshaggrid(this.invExistencias, this.defaultColDefInvutilExtencias.objeto);
    this.showBar = false;
    this.spin = false;
  }

  async buscarTodos() {
    this.confirmationService.confirm({
      message: 'Está seguro de buscar todo el inventario',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarinvUtilExist',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.confirmationService.close();
        if (this.desplegarCheck === true) {
          this.txtCodBodega = '';
          this.buscarArticulos(this.codigos);
        } else if (this.txtCodBodega === '') {
          this.mensajeAlerta('info', 'Información', 'Debe seleccionar una bodega para poder realizar la consulta');
        } else {
          this.buscarArticulos([this.txtCodBodega]);
        }
      }, reject: () => {
        this.confirmationService.close();
      }
    });

  }

  async buscarArticulos(codigos: string[]) {
    this.invExistencias = [];
    this.spin = true;
    // this.arrayCompleto = false;
    /**
     * ===================        DECLARAR PROMESAS   ============================
     */
    const promesas = codigos.map(async cod => {
      return await this.invUtilExistService.generateSingle(cod, null, this.configuraciones[0].valor, this.configuraciones[5].valor, this.configuraciones[6].valor).then((res: Invutilextencia[]) => {
        return res;
      });
    });

    /**
     *  =============    EJECUTAR PROMESAS ==============
     */

    await Promise.all(promesas).then(articulos => {
      // this.spin = false;

      articulos.map(art => {
        this.invExistencias.push(...art);
      });

    }).then(() => {
      this.invExistencias.map(inv => {
        inv.NUMERO = this.invExistencias.indexOf(inv) + 1;
      });
      this.spin = false;
      //if(this.configuraciones[4].valor === 1){
      this.getPrecios(this.invExistencias);//------------------PERMISOS PARA VER LISTA DE PRECIOS 
      //}


    })
      .catch(e => {
        console.error(e);
        const mensaje = this.errorService.generarMensajeErrorCompleto(e.error);
        this.mensajeAlerta('error', 'Error', mensaje);
      });





  }

  async getPrecios(articulos: Invutilextencia[]) {
    if (this.configuraciones[0].valor === 0) {
      this.columnDef.splice(8);
      if (this.invUtilExistService.usuarioEsquema.esquema === 'UIO1793189664001'
        && this.invUtilExistService.usuario.codperfil === 'VENT') {
        this.columnDef.splice(6,1);

      }
    } else {
      this.columnDef.splice(9);
      if (this.invUtilExistService.usuarioEsquema.esquema === 'UIO1793189664001'
        && this.invUtilExistService.usuario.codperfil === 'VENT') {
        this.columnDef.splice(6,1);
      }
    }

    this.porcentaje = 0;
    this.showBar = true;
    const porCiento: number = (articulos.length >= 50000) ? (100 / 50000) : 100 / articulos.length;



    for (const articulo of articulos) {
      if (this.configuraciones[2].valor === 0 || (this.configuraciones[2].valor === 1 && articulo.EXISTENCIA !== 0)) {

        await this.invUtilExistService.getPrecios(articulo.ART_CODIGO, this.configuraciones[1].valor, this.configuraciones[3].valor)
          .then(async precios => {
            // console.log(precios);
            if (this.configuraciones[4].valor === 1) {
              precios.map(async p => {

                const nombreCampo = 'precio' + p.ARTPRE_CODIGO; //
                articulo[nombreCampo] = p.ARTPRE_PRECIO.toFixed(2); // crear un campo de un objeto de nombre igual a un string



                const columna = this.columnDef.find(column => column.field === nombreCampo); // buscar columna del columnDef

                if (columna === undefined) { // si no existe la columna se agrega nueva;

                  this.columnDef.push( // aqui agrego nuevas colmnas
                    {
                      headerName: 'Precio ' + p.ARTPRE_CODIGO, field: nombreCampo, cellEditor: 'cellPrueba', width: 100, cellStyle: { textAlign: 'right' }, editable: false,
                      cellEditorParams:
                      {
                        values: {
                          mayusculas: true,
                          numeros: true,
                          alphabetic: true,
                          saltoslinea: 1,
                          newrow: false,
                          numerodecimales: 0,
                          obligatorio: true,
                          fecha: false,
                          tamanocelda: 10,
                          tienecalculos: false,
                        }
                      }
                    },
                  );

                }
                // const detexis= await this.invUtilExistService.insertarexisteciaspre(articulo);
              });
            }
            //}else{
            // const detexis= await this.invUtilExistService.insertarexistecias(articulo);
            //}

          })
          .catch(e => {
            console.error(e);
            const mensaje = this.errorService.generarMensajeErrorCompleto(e.error);
            this.mensajeAlerta('error', 'Error', mensaje);
          });

      }



      this.porcentaje += porCiento;

      if ((articulos.indexOf(articulo) + 1) >= 50000) {


        this.columnDefInvExistencias = this.columnDef;
        this.aggrid.isEditable(false);
        this.aggrid.refreshColumnDefs();
        this.aggrid.refreshaggrid(this.invExistencias, this.defaultColDefInvutilExtencias.objeto);
        this.showBar = false;
       
        break;
      }
    }
    // this.arrayCompleto = false;
    this.columnDefInvExistencias = this.columnDef;
    this.aggrid.refreshColumnDefs();
    this.aggrid.refreshaggrid(this.invExistencias, this.defaultColDefInvutilExtencias.objeto);
    this.showBar = false;
    if (this.invUtilExistService.usuarioEsquema.esquema === 'UIO1793189664001'
    && this.invUtilExistService.usuario.codperfil === 'VENT') {
    this.aggrid.hideColumn('EXISTENCIA', false);

  }
  }



  selectArticulo(elemento) {
    if (elemento.object !== null) {
      this.seletedInvExistencia = elemento.object;
    }
  }
  async cambio(event) {
    this.desplegarCheck = event.checked;

    if (this.desplegarCheck === true) {
      this.spin = true;
      this.txtCodBodega = '';
      this.codigos = []
      await this.invUtilExistService.getBodegas().then(async (codBodegas: any[]) => {


        codBodegas.map(async bod => {
          this.codigos.push(bod.BOD_CODIGO);
        });
        // this.buscarArticulos (codigos);
        this.spin = false;
      }).catch(e => {
        console.error(e);
        const mensaje = this.errorService.generarMensajeErrorCompleto(e.error);
        this.mensajeAlerta('error', 'Error', mensaje);
        this.spin = false;
      });


    }
  }


  async manejarSeleccion(bodega) {
    this.displayDialogBusquedaFast = false;
    this.txtCodBodega = bodega.BOD_CODIGO;
    // await this.buscarArticulos ([bodega.BOD_CODIGO]);

  }

  manejarSeleccionArticulo(articulos) {
    // console.log( articulos );
    // this.invExistencias = event;
    this.invExistencias = [];
    articulos.map(articulo => {
      articulo.NUMERO = articulos.indexOf(articulo) + 1;
    });

    this.invExistencias = articulos;
    this.displayDialogBusqueda = false;
    //if(this.configuraciones[4].valor === 1){
    this.getPrecios(this.invExistencias);//------------------PERMISOS PARA VER LISTA DE PRECIOS 
    //}


  }

  abrirKardex() {
    if (this.seletedInvExistencia !== undefined) {
      this.mostrarKardex(this.seletedInvExistencia.ART_CODIGO);
    }
  }



  mostrarKardex(codArticulo: string) {
    this.displayDialogKardex = true;
    const hora = '01:00';
    const fecha = '01/01/1970';
    this.artService.getKardex(codArticulo, fecha, hora).toPromise().then((kardex: InvTrnkardexp[]) => {

      if (kardex !== null) {
        for (const o of kardex) {
          o.TRNART_FECHAES = this.datePipe.transform(o.TRNART_FECHAES, 'dd/MM/yyyy');
        }
      }


      this.trnkardexp = kardex;
      this.trnkardexp.map((item) => {
        // item.TRNART_CANTIDAD_E = item.TRNART_CANTIDAD_E.toFixed(this.artService.obtenerConfig('CANTIDAD', 'kardex'));
        // item.TRNART_CANTIDAD_S = item.TRNART_CANTIDAD_S.toFixed(this.artService.obtenerConfig('CANTIDAD', 'kardex'));
        item.TRNART_COSTO_UNITARIO = item.TRNART_COSTO_UNITARIO.toFixed(2);
        item.TRNART_COSTOT = item.TRNART_COSTOT.toFixed(2);
        item.TRNART_CANTIDAD_SALDO = item.TRNART_CANTIDAD_SALDO.toFixed(2);
        item.TRNART_COSTOPROM = item.TRNART_COSTOPROM.toFixed(2);
        item.TRNART_COSTOT_SALDO = item.TRNART_COSTOT_SALDO.toFixed(2);

      });
    });
  }


  mensajeAlerta(tipo, titulo, mensaje) {
    this.messageService.add({
      key: 'invUtilExistoast',
      severity: tipo,
      summary: titulo,
      detail: mensaje
    });
  }

}
